import React, { Component } from "react";

import "./table.css";

import ConsultaOrderView from "./consulta-order-view";

import Moment from "moment";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";

class ConsultaTableLine extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
    this.toggle = this.toggle.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pagina !== this.props.pagina) {
      this.setState({ expanded: false });
    }
  }

  toggle() {
    this.setState(prevState => ({ expanded: !prevState.expanded }));
  }

  render() {
    const { item } = this.props;
    const { expanded } = this.state;
    const Chevron = expanded ? ChevronUp : ChevronDown;

    return (
      <tbody className={`consulta-main-table-body${expanded ? " is--expanded" : ""}`}>
        <tr className={expanded ? "consulta-row-has-expanded" : ""} data-result={this.props.index}>
          <td>{item.idPedidoOpticlick || "-"}</td>
          <td>{item.idPedidoOtica || "-"}</td>
          <td>{item.dataCriacao ? Moment(item.dataCriacao).format("DD/MM/YYYY") : "-"}</td>
          <td className="consulta-tab-cell text-right">
            <button className={`consulta-action-btn${expanded ? " is--active" : ""}`} onClick={this.toggle}>
              <span>Ver detalhes</span>
              <Chevron size={14} />
            </button>
          </td>
        </tr>

        <tr className="consulta-main-table-row-details">
          {expanded && (
            <td colSpan="4" className="consulta-main-table-row-details-td" data-details={this.props.index}>
              <ConsultaOrderView
                pedidoId={item.id}
                idPedidoOpticlick={item.idPedidoOpticlick}
                idPedidoOtica={item.idPedidoOtica}
                dataCriacao={item.dataCriacao}
                laboratorio={this.props.laboratorio}
              />
            </td>
          )}
        </tr>
      </tbody>
    );
  }
}

export default ConsultaTableLine;
